import { spawn, call, takeLatest, put, all, delay } from 'redux-saga/effects';

// Actions
import { desafiosAction } from '../../../../application/actions/desafios';
import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiobtener = api(process.env.REACT_APP_URL);

export function* fetchObtenerFuncion(params) {
  try {
  
    
    yield put(loadersActions.changeStatusObtener({ isLoading: true }));

    const { data } = yield call(apiobtener.post, 'desafio/obtener', '' , { 
      'Track-Id': params.payload
     });

    yield put(loadersActions.changeStatusObtener({ isLoading: false }));

    if (data) {
      yield put(desafiosAction.fetchDesafiosSuccess({ respuestaServicio: data }));
    } else {
      yield put(desafiosAction.fetchDesafiosError());

    }

  } catch {
      //Errores
    yield all([
      put(desafiosAction.fetchDesafiosError())
    ]);
  }
}

export function* fetchSolicitar(params) {
  try {
    yield put(loadersActions.changeStatusLoaderTercerFactorSolicitar({ isLoading: true }));
    const { data } = yield call(apiobtener.post, 'desafio/tercerfactor/solicitar', '' , { 
      'Track-Id': params.payload
    });
    yield put(loadersActions.changeStatusLoaderTercerFactorSolicitar({ isLoading: false }));

    if ('codigo' in data && data.codigo === '0') {
      yield put(desafiosAction.fetchDesafioSolicitarSuccess({ tercerFactor: { solicitar: { codigo: data.codigo, celular: data.data.celular } } } ));
    } else if ('codigo' in data && data.codigo !== '0') {
      yield put(desafiosAction.fetchDesafioSolicitarSuccess({ tercerFactor: { solicitar: { codigo: data.codigo } } } ));
    } else {
      yield put(desafiosAction.fetchDesafioSolicitarError());
    }
  } catch {
    yield put(desafiosAction.fetchDesafioSolicitarError());
  }
}

export function* fetchValidar(params) {
  try {
    const body = {
      'otp': params.payload.otp,
    };
    yield put(loadersActions.changeStatusLoaderTercerFactorValidar({ isLoading: true }));
    const { data } = yield call(apiobtener.post, 'desafio/tercerfactor/validar', body , { 
      'Track-Id': params.payload.trackId
    });
    yield put(loadersActions.changeStatusLoaderTercerFactorValidar({ isLoading: false }));

    if (data.codigo) { 
      yield put(desafiosAction.fetchDesafioValidarSuccess({ codigo: data.codigo }));
    } else {
      yield put(desafiosAction.fetchDesafioValidarError());

    }
  } catch {
    yield put(desafiosAction.fetchDesafioValidarError());
  }
}

export function* watchFetchObtener() {
  yield takeLatest(desafiosAction.fetchDesafios.type, fetchObtenerFuncion);
}

export function* watchFetchSolicitar() {
  yield takeLatest(desafiosAction.fetchDesafioSolicitar.type, fetchSolicitar);
}

export function* watchFetchValidar() {
  yield takeLatest(desafiosAction.fetchDesafioValidar.type, fetchValidar);
}

export default function* rootSaga() {
  yield spawn(watchFetchObtener);
  yield spawn(watchFetchSolicitar);
  yield spawn(watchFetchValidar);
}
